import { FC, memo } from 'react';
import { SettingsCalls } from '../../components/SettingsCalls/SettingsCalls';

export const SettingsCallsScreen: FC = memo(() => {
  return <SettingsCalls />;
});

SettingsCallsScreen.displayName = 'SettingsCallsScreen';
